import React, { Fragment } from "react";

const MentorSocial = ({ profile }) => {
  return (
    <Fragment>
      {(profile.sociallinks && profile.sociallinks.youtube !== "") ||
        (profile.sociallinks && profile.sociallinks.tiktok !== "") ||
        (profile.sociallinks && profile.sociallinks.discord !== "") ||
        (profile.sociallinks && profile.sociallinks.facebook !== "") ||
        (profile.sociallinks && profile.sociallinks.twitter !== "") ||
        (profile.sociallinks && profile.sociallinks.instagram !== "") ||
        (profile.sociallinks && profile.sociallinks.snapchat !== "" && (
          <div className="stream-section-container">
            <div className="padding-container">
              <div className="title-container-info">
                <div className="border-alt red">
                  <p className="online-title-alt red">Social Media</p>
                </div>
              </div>
              <div className="social-media-content">
                <ul className="stream-container-items-alt">
                  {profile.sociallinks &&
                    profile.sociallinks.youtube !== "" && (
                      <li className="stream-container-item">
                        <i className="fab fa-youtube fa-lg red mx-5"></i>
                        YouTube
                        <i className="fas fa-long-arrow-alt-right fa-lg red mx-5"></i>
                        {profile.sociallinks.youtube}
                      </li>
                    )}
                  {profile.sociallinks && profile.sociallinks.tiktok !== "" && (
                    <li className="stream-container-item">
                      <i className="fab fa-tiktok fa-lg red mx-5"></i>
                      TikTok
                      <i className="fas fa-long-arrow-alt-right fa-lg red mx-5"></i>
                      {profile.sociallinks.tiktok}
                    </li>
                  )}
                  {profile.sociallinks &&
                    profile.sociallinks.discord !== "" && (
                      <li className="stream-container-item">
                        <i className="fab fa-discord fa-lg red mx-5"></i>
                        TikTok
                        <i className="fas fa-long-arrow-alt-right fa-lg red mx-5"></i>
                        {profile.sociallinks.discord}
                      </li>
                    )}
                  {profile.sociallinks &&
                    profile.sociallinks.instagram !== "" && (
                      <li className="stream-container-item">
                        <i className="fab fa-instagram fa-lg red mx-5"></i>
                        Instagram
                        <i className="fas fa-long-arrow-alt-right red mx-5"></i>
                        {profile.sociallinks.instagram}
                      </li>
                    )}
                  {profile.sociallinks &&
                    profile.sociallinks.facebook !== "" && (
                      <li className="stream-container-item">
                        <i className="fab fa-facebook-square fa-lg red mx-5"></i>
                        Facebook
                        <i className="fas fa-long-arrow-alt-right fa-lg red mx-5"></i>
                        {profile.sociallinks.facebook}
                      </li>
                    )}
                  {profile.sociallinks &&
                    profile.sociallinks.twitter !== "" && (
                      <li className="stream-container-item">
                        <i className="fab fa-twitter-square fa-lg red mx-5"></i>
                        Twitter
                        <i className="fas fa-long-arrow-alt-right fa-lg red mx-5"></i>
                        {profile.sociallinks.twitter}
                      </li>
                    )}
                  {profile.sociallinks &&
                    profile.sociallinks.snapchat !== "" && (
                      <li className="stream-container-item">
                        <i className="fab fa-snapchat-ghost fa-lg red mx-5"></i>
                        Snapchat
                        <i className="fas fa-long-arrow-alt-right red mx-5"></i>
                        {profile.sociallinks.snapchat}
                      </li>
                    )}
                </ul>
              </div>
            </div>
          </div>
        ))}
    </Fragment>
  );
};

export default MentorSocial;
